import { Component, OnInit, Input } from '@angular/core';
import { PageService } from '../../services/page.service';
import { AppService } from '../../services/app.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe';
import { URL_PATTERN } from 'src/data/regex';
import { AssetTypePipe } from 'src/app/pipes/asset-type.pipe';
interface  LanguageObject {
  languageCode: string;
  value: string;
}

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  @Input() public data: {customGetAPI?: Object | string, entityInformation?: Object | string };

  @Input() config: {
    width?: number,
    height?: string | number,
    source?: string | number,
    video: Array<LanguageObject> | string,
    controls: boolean,
    autoplay: boolean,
    mapping?: {
      videoKey: string
      }
  };

  width: string = '100%';
  height:string = '320px';
  src: string;

  constructor(
    private pageService: PageService,
    private appService: AppService,
    public multiLangPipe: MultiLangPipe,
    public assetTypePipe: AssetTypePipe
  ) { }

  ngOnInit() {
    let param = [];
    let currentLang: string;

    currentLang = this.pageService.appLang$.getValue();

    if (this.config) {
      if (this.config.hasOwnProperty('width') && this.config.width) {
        this.width = `${this.config.width}px`;
      }

      if (this.config.hasOwnProperty('height') && this.config.height) {
        this.height = `${this.config.height}px`;
      }

      if (this.config.hasOwnProperty('video') && this.config.video) {
        this.src = this.getVideoSrc(this.config.video, currentLang);
      }

      if (this.config.hasOwnProperty('mapping') && this.config.mapping.hasOwnProperty('videoKey')) {

        if (typeof this.config.mapping.videoKey === 'string' && this.config.source === 2) {
            const path = this.config.mapping.videoKey.split('.');
            const video = this.appService.findObjectByPath(this.data['entityInformation'], path);
            this.src = this.getVideoSrc(video, currentLang);
          }
      }

      if (this.config.hasOwnProperty('source') && this.config.source) {
        if (this.src && this.config.source === 3) {

          let videoLink = this.src;

          if (videoLink.indexOf('youtube') !== -1) {
            this.src = this.getYoutubeEmbedUrl(videoLink);
          }

          if (videoLink.indexOf('vimeo') !== -1) {
            this.src = this.getVimeoEmbedUrl(videoLink);
          }
        }
      }

      if (this.config.hasOwnProperty('autoplay') && this.config.autoplay) {
        param.push('autoplay=1');
        param.push('autopause=0');
      }

      if (this.config.hasOwnProperty('controls') && !this.config.controls) {
        param.push('controls=0');
      }

      if (this.src && param.length > 0) {
        let paramString = param.join('&');
        this.src = this.src.concat(`?${paramString}`);
      }

      // Check if url is valid or not.
      if (!URL_PATTERN.test(this.src)) {
        this.src = '';
      }
    }
  }

  /**
   * get video link for src
   * @param videoConfig [ contain multilangArray of url or url ]
   * @param currentLang [ current app language]
   * @author Lalitkumar Saindane
   * @return [string]
   * @task QLIKTAG-3361
   */
  getVideoSrc(videoConfig: Array<LanguageObject> | string, currentLang: string): string {
    let result: any = '';
    if (this.appService.isAssetType(videoConfig)) {
      result = this.assetTypePipe.transform(videoConfig);
    } else if (Array.isArray(videoConfig)) {
      if (this.appService.isMultiLangArray(videoConfig)) {
        result = this.multiLangPipe.transform(videoConfig, currentLang);
      }
    } else {
      result = videoConfig;
    }
    // console.log({result});
    return result;
  }

    /**
   * get Youtubevideo link for src
   * @param link [Youtube url]
   * @author Lalitkumar Saindane
   * @author Neil C
   * @return [string]
   * @task QLIKTAG-3361
   */
  getYoutubeEmbedUrl(link: string): string {
    let embedUrl = 'https://www.youtube.com/embed';
    let url, searchParams;
    let videoId;
    
    if(link){
      url = new URL(link.toString());
    }
    
    if(url){
      searchParams = new URLSearchParams(url.search);
    }
    

    if(url.pathname.indexOf('embed') != -1){ //already an embed url
      return link;
    }
    
    //if it is a browser url
    if(searchParams && searchParams.has('v')){
      videoId = searchParams.get('v');
    }

    embedUrl = `${embedUrl}/${videoId}`;

    // if (link.indexOf('watch') !== -1) {

    //   let index = link.indexOf('v=');
    //   const id = link.slice(index + 2, link.length);
    //   result = result + id;

    // } else {
    //     result = link;
    // }
    console.log(embedUrl);
    return embedUrl;
  }

    /**
   * get Vimeovideo link for src
   * @param link [Vimeo url]
   * @author Lalitkumar Saindane
   * @author Neil C
   * @return [string]
   * @task QLIKTAG-3361
   */
  getVimeoEmbedUrl(link: string): string {
    let embedUrl = 'https://player.vimeo.com/video';
    let url;
    let videoId = '';
    if(link){
      url = new URL(link.toString());
    }

    if(url.pathname.indexOf('player.vimeo.com/') != -1){ //already an embed url
      return link;
    }

    if(url){
      videoId = url.pathname.split('/').pop();
    }

    embedUrl = `${embedUrl}/${videoId}`;

    // if (link.indexOf('player') === -1) {
    //   const id = link.split('/').pop();
    //   result = result + id;
    // } else {
    //   result = link;
    // }
    return embedUrl;
  }

  /**
   * Check if passed object is video asset type
   * @param item 
   * @author Neil C
   */
  isVideoAssetType(item: any):boolean {
    let result: boolean = false;

    if (item && item.hasOwnProperty('languageCode') && 
    item.hasOwnProperty('url') && 
    item.hasOwnProperty('type') && 
    item.type === 'video') {
      result = true;
    }


    return result;

  }

}
